import { Link } from "react-router-dom";
import img404 from './Assets/img-min/svg/404.svg';
import HeaderHero from "./Contact/HeaderHero";
import { useEffect } from "react";
function Page404() {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return (
        <>
            <HeaderHero Name={'404'} />
            <div id="overview" className="section py-6 py-md-7 bg-body">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 px-6 px-md-8 px-lg-7 px-xl-8 text-center mb-5 mb-lg-0" data-aos="fade-up">
                            <img src={img404} className="img-fluid" alt="Not found" />
                        </div>
                        <div className="col-lg-6 align-self-center" data-aos="fade-up">
                            <div className="max-box text-center text-lg-start">
                                <h1 className="display-1 fw-bold">404</h1>
                                <p className="lead mb-5">Oops! That page can&#39;t be found.<br />It looks like nothing was found at this location.</p>
                                <Link to='/' className="btn btn-primary">
                                    <svg className="bi bi-house me-2" width="1.2rem" height="1.2rem" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" d="M2 13.5V7h1v6.5a.5.5 0 00.5.5h9a.5.5 0 00.5-.5V7h1v6.5a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 012 13.5zm11-11V6l-2-2V2.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5z" clipRule="evenodd"></path>
                                        <path fillRule="evenodd" d="M7.293 1.5a1 1 0 011.414 0l6.647 6.646a.5.5 0 01-.708.708L8 2.207 1.354 8.854a.5.5 0 11-.708-.708L7.293 1.5z" clipRule="evenodd"></path>
                                    </svg>Back to Home</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Page404;